import moment from 'moment';
import React, { Component } from 'react';
import Session from '../../Service/Session';
import { VERIFY_AUTHORIZATION } from '../Util/userType_constants';
import { hot } from 'react-hot-loader';

class SideNav extends Component {
	render() {
		const current_user_info = Session.get('CURRENT_USER_INFO');
		const { isSUPER_ADMIN } = VERIFY_AUTHORIZATION(current_user_info);

		let userName = current_user_info ? current_user_info.attributes.name : '';
		userName = userName
			.split(' ')
			.map(word => word.charAt(0).toUpperCase() + word.slice(1))
			.join(' ');
		let userNameFontSize = 20;
		if (userName.length > 21) {
			userNameFontSize -= Math.floor(
				(userName.length - 21) /
					(userName.length < 24
						? 1
						: userName.length < 28
						? 1.2
						: userName.length < 32
						? 1.3
						: userName.length < 36
						? 1.5
						: userName.length < 40
						? 1.7
						: 2)
			);
		}

		const fromDate = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
		const toDate = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');
		return (
			<div className="sidebar">
				{/* Sidebar user (optional) */}
				<div className="user-panel mt-3 pb-3 mb-3 d-flex">
					<div className="info">
						<a
							className="d-block"
							href="#void"
							onClick={e => {
								e.preventDefault();
							}}
							style={{ fontSize: `${userNameFontSize}px` }}>
							{userName || ''}
						</a>
					</div>
				</div>
				{/* Sidebar Menu */}
				<nav className="mt-2">
					<ul
						className="nav nav-pills nav-sidebar flex-column"
						data-accordion="false"
						data-widget="treeview"
						role="menu"
						style={{ cursor: 'pointer' }}>
						<li className="nav-item has-treeview">
							<a
								className="nav-link"
								href="#void"
								onClick={_e => {
									window.location.href = '/';
								}}>
								<i className="nav-icon fas fa-home" />
								<p>Home</p>
							</a>
						</li>
						<li className="nav-item has-treeview">
							<a
								className="nav-link"
								href="#void"
								onClick={_e => {
									window.location.href = '/admin';
								}}>
								<i className="nav-icon fas fa-user" />
								<p>Customers</p>
							</a>
						</li>
						<li className="nav-item has-treeview">
							<a
								className="nav-link"
								href="#void"
								onClick={_e => {
									window.location.href = `/admin/transactions?channel=&fromDate=${fromDate}&page=0&status=ALL&toDate=${toDate}&type=ALL`;
								}}>
								<i className="nav-icon fas fa fa-exchange" />
								<p>Transactions</p>
							</a>
						</li>
						{isSUPER_ADMIN ? (
							<li className="nav-item has-treeview">
								<a
									className="nav-link"
									href="#void"
									onClick={_e => {
										window.location.href = '/admin/permissions';
									}}>
									<i className="nav-icon fas fa fa-lock" />
									<p>Permissions</p>
								</a>
							</li>
						) : null}

						<li className="nav-item has-treeview">
							<a
								className="nav-link"
								href="#void"
								onClick={_e => {
									window.location.href = '/admin/service_charge';
								}}>
								<i className="nav-icon fas fa fa-money" />
								<p>Service Charge</p>
							</a>
						</li>
						<li className="nav-item has-treeview">
							<a
								className="nav-link"
								href="#void"
								onClick={_e => {
									window.location.href = '/admin/dashboard';
								}}>
								<i className="nav-icon fas fa fa-dashboard" />
								<p>Dashboard</p>
							</a>
						</li>
						{/* hide tenants for now */}
						{/* <li className="nav-item has-treeview">
							<a
								className="nav-link"
								href="#void"
								onClick={_e => {
									window.location.href = '/admin/tenants';
								}}>
								<i className="nav-icon fas fa-user" />
								<p>Tenants</p>
							</a>
						</li> */}
					</ul>
				</nav>
			</div>
		);
	}
}

export default hot(module)(SideNav);
